<div class="filter-help-content">
    <h3>How to Use Column Filters</h3>
    
    <div class="help-section">
        <h4><i class="pi pi-filter"></i> Basic Filtering</h4>
        <p>Click the filter icon in any column header to open the filter menu.</p>
    </div>

    <div class="help-section">
        <h4><i class="pi pi-check-square"></i> Multi-Select Filters</h4>
        <ul>
            <li>Use the dropdown to select one or more values to filter by</li>
            <li>Selected items will be displayed in the filter</li>
            <li>Use the search box to quickly find specific values</li>
            <li>Click outside or press ESC to close the filter menu</li>
        </ul>
    </div>

    <div class="help-section">
        <h4><i class="pi pi-calendar"></i> Date Filters</h4>
        <ul>
            <li>Use the calendar to select a date or date range to filter</li>                       
            <li>To select a date range, follow these steps:</li>
            <ol>            
                <li>Choose "Date is after", then pick a date</li>
                <li>Click "Add Rule"</li>
                <li>Choose "Date is before", then pick a date</li>
            </ol>
            <li>Click outside or press ESC to close the filter menu</li>
        </ul>       
    </div>

    <div class="help-section">
        <h4><i class="pi pi-times-circle"></i> Clearing Filters</h4>
        <ul>
            <li>Click the "Clear" button in the filter menu to remove all filters for that column</li>
            <li>Deselect individual items to remove them from the filter</li>
        </ul>
    </div>

    <!-- <div class="help-section">
        <h4><i class="pi pi-info-circle"></i> Tips</h4>
        <ul>
            <li>You can filter multiple columns simultaneously</li>
            <li>Filters are applied immediately as you make selections</li>
            <li>The filter icon will be highlighted when a filter is active</li>
            <li>Use the search feature in dropdowns to quickly find specific items</li>
        </ul>
    </div> -->

    <div class="dialog-footer">
        <button pButton type="button" label="Close" (click)="close()" class="p-button-primary"></button>
    </div>
</div>
